import React, { useCallback, useEffect, useState } from 'react';
import Header from '../Header/Header';
import {
  PageContent,
  LayoutColumns,
  SideImage,
  LoaderContainer,
} from './PageLayout.styled';
import { MoonLoader } from 'react-spinners';
import { theme } from '../../styles/styles';

const PageLayout = ({ children, page, sideImage }) => {
  const [minimize, setMinimize] = useState(
    document.documentElement.scrollTop !== 0,
  );
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const handleScroll = () =>
      setMinimize(document.documentElement.scrollTop !== 0);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setImageLoaded(false);
  }, [sideImage?.src]);

  const imgCallbackRef = useCallback((el) => {
    if (el?.complete) setImageLoaded(true);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const showLoader = sideImage && !imageLoaded;

  return (
    <>
      <Header minimize={minimize} page={page} />
      {showLoader && (
        <LoaderContainer>
          <MoonLoader color={theme.secondaryColor} />
        </LoaderContainer>
      )}
      {sideImage ? (
        <LayoutColumns
          style={{ visibility: showLoader ? 'hidden' : 'visible' }}
        >
          <SideImage
            ref={imgCallbackRef}
            src={sideImage.src}
            alt={sideImage.alt}
            $minimize={minimize}
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageLoaded(true)}
          />
          <PageContent $minimize={minimize}>{children}</PageContent>
        </LayoutColumns>
      ) : (
        <PageContent $minimize={minimize}>{children}</PageContent>
      )}
    </>
  );
};

export default PageLayout;
